export const INSTRUCTIONS_MEET = [
    {
      id: 1,
      svg: "/icons/instr1.svg",
      title: "Лайк",
      description:
        "Если вам понравился человек и вы хотели бы начать общение – поставтье лайк",
    },
    {
      id: 2,
      svg: "/icons/instr2.svg",
      title: "Супер-Лайк",
      description:
        "Супер-лайк отобразится в уведомлениях человека, который вам понравился, и не останется незамеченным",
    },
    {
      id: 3,
      svg: "/icons/instr3.svg",
      title: "Дизлайк",
      description: "Если анкета вам не интересна – поставтье дизлайк",
    },
    {
      id: 4,
      svg: "/icons/instr4.svg",
      title: "Начать переписку",
      description:
        "Вы уверены в своих силах и не хотите дожидаться симпатии? Напишите первым",
    },
    {
      id: 5,
      svg: "/icons/instr5.svg",
      title: "Вернуть предыдущую анкету",
      description: "Верните предыдущую анкету человека, вдруг это ваша судьба",
    },
    {
      id: 6,
      svg: "/icons/instr6.svg",
      title: "Просмотр фотографий",
      description:
        "Чтобы листать фотографии нажмите на левую или правую область фото",
    },
    {
      id: 7,
      svg: "/icons/instr7.svg",
      title: "Просмотр анкеты",
      description:
        "Листайте анкету вниз, чтобы увидеть дополнительную информацию о человеке",
    },
  ];

export const INSTRUCTIONS_VIDEOCHAT = [
  {
      id: 1,
      svg: "/icons/instructions_timer_25sec.svg",
      title: "25 секунд",
      description:
          "У вас есть 25 секунд, чтобы определить, нравится ли вам человек или нет",
  },
  {
      id: 2,
      svg: "/icons/instr1.svg",
      title: "Лайк",
      description:
          "Если вам понравился человек и вы хотели бы продолжить общение в переписке – поставтье лайк",
  },
  {
      id: 3,
      svg: "/icons/instr3.svg",
      title: "Дизлайк",
      description: "Хотите перейти к следующему собеседнику – поставтье дизлайк",
  },
  {
      id: 4,
      svg: "/icons/instr4.svg",
      title: "Начать переписку",
      description:
          "Не хотите дожидаться симпатии? Напишите первым",
  }
];
